import { Contexte } from '@/domaine/Contexte'

export const situationSalarié: Contexte = {
	dirigeant: 'non',
	'entreprise . catégorie juridique': "''",
	'entreprise . imposition': 'non',
}
